import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Button, CircularProgress, List, ListItem, ListItemText } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { getSynthesisConfiguration } from '../../services/synthesisConfigService';
import { SynthesisConfigurationResponse } from '../../types/synthesisConfig';
import swal from 'sweetalert';

const SynthesisConfigurationDetail: React.FC = () => {
  const { cfgId } = useParams<{ cfgId: string }>();
  const [config, setConfig] = useState<SynthesisConfigurationResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const fetchConfig = async () => {
    if (!cfgId) return;
    setLoading(true);
    try {
      const data = await getSynthesisConfiguration(cfgId);
      setConfig(data);
    } catch (error) {
      console.error("Erro ao buscar configuração:", error);
      swal("Erro", "Não foi possível carregar a configuração.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfig();
  }, [cfgId]);

  if (loading) {
    return (
      <Box sx={{ textAlign: 'center', mt: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!config) {
    return (
      <Typography variant="h6" color="error">
        Configuração não encontrada.
      </Typography>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Button variant="contained" onClick={() => navigate(-1)}>
          Voltar
        </Button>
        <Button variant="contained" onClick={() => navigate(`/synthesis/configurations/${config.id}/editar`)}>
          Editar
        </Button>
      </Box>
      <Paper sx={{ p: 3 }}>
        <List>
          <ListItem>
            <ListItemText primary="ID" secondary={config.id} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Nome da Entidade" secondary={config.entity_name} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Endereço" secondary={`${config.address.street} - ${config.address.cep}`} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Criado em" secondary={new Date(config.created_at).toLocaleString()} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Atualizado em" secondary={new Date(config.updated_at).toLocaleString()} />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Membros do Conselho"
              secondary={
                config.council_members && config.council_members.length > 0
                  ? config.council_members
                      .map(member => `${member.full_name} (${member.nickname || 'sem apelido'}) [${member.type}]`)
                      .join(', ')
                  : 'Nenhum membro'
              }
            />
          </ListItem>
        </List>
      </Paper>
    </Box>
  );
};

export default SynthesisConfigurationDetail;